import React, { createContext, useContext, useState } from 'react'

interface StateProps {
  open: boolean
  showCloseButton?: boolean
  drawerContent?: React.ReactChild
}

export interface DrawerState {
  open: boolean
  onClose: () => void
  showCloseButton: boolean
  drawerContent: React.ReactChild
  setDrawerState: React.Dispatch<React.SetStateAction<StateProps>>
}

const initialState: StateProps = {
  open: false,
  showCloseButton: true,
  drawerContent: <></>,
}

//@ts-ignore
export const DrawerContext = createContext<DrawerState>(undefined)

export const DrawerProvider = ({
  children,
}: {
  children: React.ReactChild
}) => {
  const [drawerState, setDrawerState] = useState<StateProps>(initialState)
  const { open, showCloseButton = false, drawerContent = <></> } = drawerState

  return (
    <DrawerContext.Provider
      value={{
        open: open,
        showCloseButton,
        onClose: () => setDrawerState({ ...drawerState, open: false }),
        setDrawerState,
        drawerContent,
      }}
    >
      {children}
    </DrawerContext.Provider>
  )
}

export function useDrawerState() {
  return useContext(DrawerContext)
}
